<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">代理商列表</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-row>
        <el-col>
          <el-form :inline="true" :model="query" class="demo-form-inline" size="small">
            <el-form-item>
              <el-button type="primary" @click="submitQuery(1)" size="small" icon="el-icon-search">搜索</el-button>
              <el-button type="success" @click="$router.push({name:'proxyDetail'});" size="small"
                         icon="el-icon-document-add">添加代理
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <hr/>
    <div class="title">
      <span>代理商列表</span>
    </div>
    <el-table highlight-current-row :data="printers">
      <el-table-column align="center" label="代理商" prop="name"/>
      <el-table-column align="center" label="负责人" prop="principal"/>
      <el-table-column align="center" label="联系方式" prop="phoneNumber"/>
      <el-table-column align="center" label="操作" width="250px">
        <template slot-scope="scope">
          <el-button type="primary"
                     @click="$common.goRouterLink({ name: 'proxyDetail', query: { 'id': scope.row.id }})"
                     size="mini"
                     icon="el-icon-edit" round>
            编辑代理
          </el-button>

          <el-button type="danger"
                     @click="del(scope.row.id)"
                     size="mini"
                     icon="el-icon-delete" round>
            删除代理
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <vue-pager v-bind:datafile="fillData" url="proxy/pageProxy" v-bind:query="query" ref="pager"
               v-bind:init="true"></vue-pager>
  </div>
</template>
<script>
export default {
  data() {
    return {
      printers: [],
      query: {
      },
      sellers: [],
      dynamicPath: config.dynamicResourcePath,

    }
  },
  created() {
    this.pageSeller();
  },
  methods: {
    fillData(response) {
      this.printers = response.items || [];
    },
    submitQuery(_num) {
      this.$refs.pager.gotoPage(_num);
    },
    del(_id) {
      var _this = this;
      _this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$common.my_ajax({
          url: 'proxy/deleteProxy',
          data: {
            proxyId: _id
          },
          success: function () {
            _this.$message({
              message: '删除成功',
              type: 'success',
              duration: 1000,
              onClose: function () {
                _this.submitQuery(1);
              }
            });
          }
        });
      })
    },

  },
}
</script>
<style scoped>
</style>
